/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1ExclusionAddressesAttached } from '../models/V1ExclusionAddressesAttached';
import { V1ExclusionAddressesDetached } from '../models/V1ExclusionAddressesDetached';
import { V1PixelCreated } from '../models/V1PixelCreated';
import { V1PixelUpdated } from '../models/V1PixelUpdated';
import { V1SubscriptionCreated } from '../models/V1SubscriptionCreated';
import { V1SubscriptionUpdated } from '../models/V1SubscriptionUpdated';
import { HttpFile } from '../http/http';

/**
* Wrapper for the different kinds of events
*/
export class V1WebToHomeEvent {
    'eventType'?: string;
    'subscriptionCreated'?: V1SubscriptionCreated;
    'subscriptionUpdated'?: V1SubscriptionUpdated;
    'pixelCreated'?: V1PixelCreated;
    'pixelUpdated'?: V1PixelUpdated;
    'exclusionAddressesAttached'?: V1ExclusionAddressesAttached;
    'exclusionAddressesDetached'?: V1ExclusionAddressesDetached;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "eventType",
            "baseName": "event_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptionCreated",
            "baseName": "subscription_created",
            "type": "V1SubscriptionCreated",
            "format": ""
        },
        {
            "name": "subscriptionUpdated",
            "baseName": "subscription_updated",
            "type": "V1SubscriptionUpdated",
            "format": ""
        },
        {
            "name": "pixelCreated",
            "baseName": "pixel_created",
            "type": "V1PixelCreated",
            "format": ""
        },
        {
            "name": "pixelUpdated",
            "baseName": "pixel_updated",
            "type": "V1PixelUpdated",
            "format": ""
        },
        {
            "name": "exclusionAddressesAttached",
            "baseName": "exclusion_addresses_attached",
            "type": "V1ExclusionAddressesAttached",
            "format": ""
        },
        {
            "name": "exclusionAddressesDetached",
            "baseName": "exclusion_addresses_detached",
            "type": "V1ExclusionAddressesDetached",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1WebToHomeEvent.attributeTypeMap;
    }

    public constructor() {
    }
}

